App.namespace.wrap('views.shared.static_page_menu', function () {
    var $mobileMenuToggler = $('.static-page__list__element--mobile-overlap');

    (function attachMobileMenu() {
        $mobileMenuToggler.on('click', function () {
            $(this).parents('.static-page__list').toggleClass('opened');
        });
    })();
});